<script>
  export let autor;
  export let last;
</script>

<style>
  div.articleAuthorItem {
    width: 100%;
    margin-bottom: 10px;
  }

  div.name {
    font-weight: bold;
  }

  span.institucion {
    font-style: italic;
  }

  div.last {
    margin-bottom: 0px;
  }
</style>

<div class="articleAuthorItem {last ? 'last' : ''}">
  <div class="name">
    {autor.firma} - {autor.nombreUsuario} {autor.apellido1Usuario}
  </div>
  <div>
    <span class="institucion">{autor.institucionUsuario}</span>
    -
    <a href={'mailto:' + autor.email}>{autor.email}</a>
  </div>
</div>
